module.exports = __webpack_public_path__ + "static/media/icon_zip.f72e3a2d.png";